exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-fastgear-tsx": () => import("./../../../src/pages/fastgear.tsx" /* webpackChunkName: "component---src-pages-fastgear-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-timer-tsx": () => import("./../../../src/pages/timer.tsx" /* webpackChunkName: "component---src-pages-timer-tsx" */)
}

